import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";
import Grid from "../../../components/Grid";
import { MoreHorizontal } from "lucide-react";
import { ShowBtn } from "@/components/Show";
import { CreateLoaderInput } from "../../../components/Loaders";
import { DeleteBtn } from "@/components/Delete";
import { TypeTableProps } from "@/App/Plans/Table";
import { cn } from "@/lib/utils";
import { colors } from "@/utils/colors";
import { ComponentSwitchToggleStatus } from "@/App/Courses/ActivedOrDisabled";
import { UpdateBtn } from "../Update";
import { TableDataProps } from "@/pages/Stockist";
import {
  setStatusStockists,
  getShowStockists,
  deleteStockistsData,
} from "@/Api/stockists";
import LogoFavicon from "../../../../public/images/logo-favicon.png";

export const TableData = ({
  dataApi,
  pageActions,
  updateFront,
}: TypeTableProps<TableDataProps>) => {
  return (
    <>
      <Table className="bg-zinc-50 rounded dark:bg-[#2c2c2c]">
        <TableHeader>
          <TableRow>
            <TableHead>Foto</TableHead>
            <TableHead>Nome</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Unidade</TableHead>
            <TableHead className="text-center">Ativo</TableHead>
            <TableHead className="text-center">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {dataApi?.data.map((item) => {
            return (
              <TableRow key={item?.id}>
                <TableCell>
                  <img
                    src={item?.photo || LogoFavicon}
                    alt={item?.name || ""}
                    className="size-7 aspect-square object-cover rounded"
                  />
                </TableCell>
                <TableCell className="truncate max-w-80">
                  {item?.name}
                </TableCell>
                <TableCell className="truncate max-w-80">
                  {item?.email}
                </TableCell>
                <TableCell className="truncate max-w-80">
                  {item?.unity?.[0]?.name}
                </TableCell>

                <TableCell>
                  <ComponentSwitchToggleStatus
                    defaultChecked={Boolean(item?.is_active)}
                    params={{
                      func: setStatusStockists,
                      funcParams: item?.uuid,
                    }}
                    updateFront={() =>
                      updateFront((prev) => {
                        return {
                          ...prev,
                          data: prev?.data?.map((values) => {
                            if (values?.uuid === item?.uuid)
                              return {
                                ...values,
                                is_active: values.is_active ? 0 : 1,
                              };
                            return values;
                          }),
                        };
                      })
                    }
                  />
                </TableCell>
                <TableCell className="flex justify-center">
                  <div className="flex gap-3 w-full justify-center">
                    <UpdateBtn
                      params={{
                        uuid: item?.uuid,
                        updateFront,
                      }}
                    />
                    <ShowBtn
                      labels={{ title: "Estoquista" }}
                      params={{
                        func: getShowStockists,
                        funcParams: item?.uuid,
                      }}
                      render={(responseApi: TableDataProps) => (
                        <div className="grid gap-5">
                          <div className="grid grid-cols-2 gap-3">
                            <Grid.Item name="Nome" flex={0}>
                              {responseApi?.name}
                            </Grid.Item>
                            <Grid.Item name="Email" flex={0}>
                              {responseApi?.email}
                            </Grid.Item>
                          </div>
                          <div className="grid grid-cols-1 gap-3">
                            <Grid.Item name="Unidade" flex={0}>
                              {responseApi?.unity?.[0]?.name}
                            </Grid.Item>
                          </div>
                        </div>
                      )}
                      loader={<CreateLoaderInput lines={4} />}
                    />
                    <DeleteBtn
                      params={{
                        func: deleteStockistsData,
                        funcParams: item?.uuid,
                      }}
                      updateFront={() =>
                        updateFront((prev) => {
                          return {
                            ...prev,
                            data: prev?.data?.filter(
                              (values) => values?.uuid !== item?.uuid
                            ),
                          };
                        })
                      }
                    />
                  </div>
                </TableCell>
              </TableRow>
            );
          })}

          {dataApi?.data.length < 1 && (
            <TableRow>
              <TableCell colSpan={6}>Nada foi encontrado.</TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <div className="flex justify-between mb-3">
        {dataApi?.data.length > 0 && (
          <span className="font-medium">
            Exibindo {dataApi?.current_page} de um total de {dataApi?.last_page}
          </span>
        )}
        {dataApi?.last_page > 1 && (
          <Pagination>
            <PaginationContent>
              <PaginationItem>
                <PaginationPrevious
                  href="#"
                  className={cn("h-8", colors.bg_primary)}
                  onClick={pageActions.previous}
                />
              </PaginationItem>
              <PaginationItem>
                <PaginationLink
                  href="#"
                  className={cn(
                    `size-8 bg-transparent border-2 border-[#023859] text-slate-900 font-bold cursor-auto hover:bg-transparent`
                  )}
                >
                  <span className="pointer-events-none dark:text-[#F4F4F5]">
                    {dataApi?.current_page}
                  </span>
                </PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink
                  href="#"
                  className="text-black h-8 hover:bg-stone-950/10"
                  onClick={pageActions.lastPage}
                >
                  <MoreHorizontal className="h-4 w-4 dark:text-[#F4F4F5]" />
                </PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationNext
                  href="#"
                  className={cn("h-8", colors.bg_primary)}
                  onClick={pageActions.next}
                />
              </PaginationItem>
            </PaginationContent>
          </Pagination>
        )}
      </div>
    </>
  );
};